// extracted by mini-css-extract-plugin
export default {"textAlignCenter":"hFflxN","textAlignLeft":"PH6rNQ","textAlignRight":"b5s3Zx","textAlignJustify":"ykRC1S"};